import React from "react";
import ReactDOM from "react-dom";
import { loadYmaps3 } from "./loadYmaps3";

let componentsPromise = null;

function resetComponentsPromise() {
  componentsPromise = null;
}

export function getYmaps3ReactComponents() {
  if (!componentsPromise) {
    componentsPromise = (async () => {
      try {
        await loadYmaps3();
        const ymaps3 = window.ymaps3;
        const [ymaps3Reactify] = await Promise.all([
          ymaps3.import("@yandex/ymaps3-reactify"),
          ymaps3.ready,
        ]);
        const reactify = ymaps3Reactify.reactify.bindTo(React, ReactDOM);
        const {
          YMap,
          YMapDefaultSchemeLayer,
          YMapDefaultFeaturesLayer,
          YMapMarker,
        } = reactify.module(ymaps3);
        return {
          reactify,
          YMap,
          YMapDefaultSchemeLayer,
          YMapDefaultFeaturesLayer,
          YMapMarker,
        };
      } catch (error) {
        resetComponentsPromise();
        throw error;
      }
    })();
  }
  return componentsPromise;
}
